import { AfterContentInit, Directive, ElementRef } from '@angular/core';

@Directive({
	selector: '[focus-select]'
})
export class FocusSelectDirective implements AfterContentInit {
	public constructor(private el: ElementRef) {}

	public ngAfterContentInit() {
		this.el.nativeElement.addEventListener('focus', () => {
			this.el.nativeElement.select();
		});
	}
}
